export function convertNumber(string) {
	let number = Number(string.replace(/[^0-9.-]+/g, ''));
	return number;
}
